
import { useResponsiveComponent } from '@/hooks/useResponsiveComponent';
import { formatGuestInfo } from '@/utils/propertyUtils';

interface PropertyInfoProps {
  guests: number;
  bedrooms: number;
  bathrooms: number;
}

const PropertyInfo = ({ guests, bedrooms, bathrooms }: PropertyInfoProps) => {
  const { showMobileVersion } = useResponsiveComponent();

  // Ocultar en móvil ya que la información se muestra en PropertyHeader
  if (showMobileVersion) {
    return null;
  }

  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-2">
          Alojamiento completo
        </h2>
        <p className="text-gray-600">{formatGuestInfo(guests, bedrooms, bathrooms)}</p>
      </div>
    </div>
  );
};

export default PropertyInfo;
